import { addBasePath } from 'next/dist/client/add-base-path';

import Cookies from 'js-cookie';
import jwtDecode, { InvalidTokenError } from 'jwt-decode';

import { ACCESS_TOKEN_COOKIE_NAME } from '../hooks/auth/constant';

export function getAccessToken(): string | null {
  return Cookies.get(ACCESS_TOKEN_COOKIE_NAME) ?? null;
}

export function setAccessToken(token: string): void {
  Cookies.set(ACCESS_TOKEN_COOKIE_NAME, token, {
    path: addBasePath('/'),
  });
}

export function removeAccessToken(): void {
  Cookies.remove(ACCESS_TOKEN_COOKIE_NAME, {
    path: addBasePath('/'),
  });
}

export type UserInfoJwt = {
  hasura: {
    'x-hasura-user-id': string;
    'x-hasura-default-role': string;
    'x-hasura-allowed-roles': string[];
  };
  iat: number;
  exp: number;
};

export function parseToken(token: string): UserInfoJwt | null {
  try {
    const userInfo = jwtDecode<UserInfoJwt>(token);

    if (!userInfo || typeof userInfo?.exp !== 'number') {
      return null;
    }

    if (userInfo.exp * 1000 < Date.now()) {
      return null;
    }

    return userInfo;
  } catch (error) {
    if (error instanceof InvalidTokenError) {
      return null;
    }

    return null;
  }
}
